import React from 'react';

const HowItWorks = () => {
  const steps = [
    {
      number: '1',
      title: 'Capture & Qualify Leads',
      desc: 'Add prospects, track their loan needs, and move qualified leads into your active pipeline with a click.'
    },
    {
      number: '2',
      title: 'Collect & Organize Documents',
      desc: 'Request, receive, and track client documents. Know exactly what\'s been submitted and what\'s still outstanding.'
    },
    {
      number: '3',
      title: 'Build the Loan Package',
      desc: 'Assemble a clean, submission-ready package with all the information lenders need to make fast decisions.'
    },
    {
      number: '4',
      title: 'Match & Submit to Lenders',
      desc: 'Identify the right lenders for each deal and submit with confidence. Track responses and manage the conversation.'
    },
    {
      number: '5',
      title: 'Close the Deal',
      desc: 'Coordinate final terms, manage signatures, and mark the deal funded — then move to the next one in your pipeline.'
    }
  ];

  return (
    <section className="how bg-slate-50 py-[90px] px-[5%]" id="how-it-works">
      <div className="text-center max-w-[860px] mx-auto">
        <div className="section-label text-[0.78rem] font-bold uppercase tracking-[0.08em] text-blue-500 mb-3">
          How It Works
        </div>
        <h2 className="section-title text-[clamp(1.6rem,3.5vw,2.4rem)] font-black leading-tight mb-4 text-slate-900">
          A clear process, from first call
          <br />
          to funded deal
        </h2>
        <p className="section-sub text-xl text-slate-600 max-w-[540px] mx-auto leading-relaxed mb-[56px]">
          The Business Lending Hub structures the broker workflow so nothing falls through the cracks.
        </p>
      </div>
      <div className="steps relative mt-[56px] grid grid-cols-1 md:grid-cols-5 gap-0 before:content-[''] before:absolute before:top-8 before:left-[10%] before:right-[10%] before:h-px before:bg-gradient-to-r before:from-blue-500 before:to-blue-300 md:before:z-0">
        {steps.map((step, index) => (
          <div key={index} className="step text-center p-0 md:px-6 relative z-10">
            <div className="step-number w-16 h-16 rounded-full bg-blue-500 text-white text-[1.3rem] font-black flex items-center justify-center mx-auto mb-6 shadow-[0_0_0_6px_#f8fafc,0_0_0_8px_#3b82f6]">
              {step.number}
            </div>
            <h3 className="text-[1.05rem] font-bold text-slate-900 mb-[10px]">{step.title}</h3>
            <p className="text-sm text-slate-600 leading-[1.65]">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;

